import React from "react";

export default function TermsPage() {
  return (
    <article className="py-20" data-testid="terms-page">
      <div className="mfb-container max-w-3xl">
        <div className="overline mb-3">Legal</div>
        <h1 className="font-[Outfit] text-5xl font-light tracking-tighter text-white">Terms &amp; Conditions</h1>
        <div className="mt-2 text-slate-500 text-sm">Effective: {new Date().toLocaleDateString()}</div>
        <div className="prose prose-invert prose-headings:font-[Outfit] prose-headings:font-light max-w-none mt-8 text-slate-300 leading-relaxed text-sm">
          <p>These Terms govern your access to and use of the services provided by My Funding Bank ("MFB").</p>
          <h3>Eligibility</h3>
          <p>You must be 18 or older and capable of forming a legally binding contract in your jurisdiction.</p>
          <h3>Account</h3>
          <p>You are responsible for safeguarding your credentials and for all activity that occurs under your account.</p>
          <h3>Risk disclosure</h3>
          <p>Investments are subject to market risks. Past performance is not indicative of future results. Forex and derivatives may carry leverage risk.</p>
          <h3>Fees</h3>
          <p>Applicable fees are disclosed in-app before any transaction. We do not charge hidden or surprise fees.</p>
          <h3>Limitation of liability</h3>
          <p>To the maximum extent permitted by law, MFB is not liable for indirect or consequential damages arising from use of the platform.</p>
          <h3>Governing law</h3>
          <p>These Terms are governed by the laws of the United Arab Emirates, without regard to conflict-of-laws principles.</p>
          <h3>Contact</h3>
          <p>Questions? Email legal@myfundingbank.com.</p>
        </div>
      </div>
    </article>
  );
}
